import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";

// Use default language for namespace types
import type common from "public/locales/en/common.json";
import type validation from "public/locales/en/validation.json";
import type glossary from "public/locales/en/glossary.json";
import type errors from "public/locales/en/errors.json";

// Define the resources so that the linter can detect it for autocomplete
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: 'common'
    resources: {
      common: typeof common
      validation: typeof validation
      glossary: typeof glossary
      errors: typeof errors
    }
  }
}

// Instantiate the language
i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.PROD ? true : false,
    fallbackLng: "en",
    defaultNS: 'common',
    ns: ['common', 'validation', 'glossary', 'errors'],
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    load: 'languageOnly', // Load only the language code (e.g., 'en' instead of 'en-US')
    detection: {
      order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
  }, (err) => {
    if (err) {
      console.error("Error initializing i18next:", err);
    } else {
      // Get the language directly from the navigator
      const lng = navigator.language; // Modern browsers support only this property
      const shortLng = lng.split('-')[0]; // Get the language code (e.g., 'en' from 'en-US')

      // Proceed only if the detected language is French
      if (shortLng === 'fr') {
        const currentUrl = new URL(window.location.href);
        const currentPath = currentUrl.pathname;

        // Assuming the language code is the first part of the path
        if (currentPath.startsWith('/en')) {
          const newPath = currentPath.replace(/^\/en/, '/fr');
          
          // Update the URL and reload the page
          window.location.replace(newPath);
        }
      }
    }
  });

// Log the language whenever it changes
i18n.on('languageChanged', (lng) => {
  console.log(`Language changed to: ${lng}`);
});

export default i18n;
